import { render, staticRenderFns } from "./FormInvoice.vue?vue&type=template&id=84c8affe&scoped=true"
import script from "./FormInvoice.vue?vue&type=script&lang=js"
export * from "./FormInvoice.vue?vue&type=script&lang=js"
import style0 from "./FormInvoice.vue?vue&type=style&index=0&id=84c8affe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c8affe",
  null
  
)

export default component.exports